export { PieCarousel } from './pie-carousel.component';
